export default __webpack_public_path__ + "static/phone-frame-c977079a3d5833d40814b510e03bf279.svg";